import React, { useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import './Auth.css';

const EmailVerification = ({ onVerificationComplete }) => {
  const { currentUser, sendVerificationEmail, isEmailVerified, signOut } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  const handleSendVerification = async () => {
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await sendVerificationEmail();
      setSuccess('Verification email sent! Please check your inbox.');
      setCountdown(60); // 60 second cooldown
    } catch (error) {
      console.error('Error sending verification email:', error);
      setError('Failed to send verification email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleStartOver = async () => {
    try {
      await signOut();
      // User will be redirected to login/signup by AuthWrapper
    } catch (error) {
      console.error('Error signing out:', error);
      setError('Failed to sign out. Please try again.');
    }
  };

  if (isEmailVerified) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="verification-success">
            <div className="success-icon">✓</div>
            <h2>Email Verified!</h2>
            <p>Your email has been successfully verified.</p>
            <button 
              onClick={onVerificationComplete}
              className="auth-button primary"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="verification-container">
          <div className="verification-icon">📧</div>
          <h2>Verify Your Email</h2>
          <p>
            We've sent a verification email to <strong>{currentUser?.email}</strong>
          </p>
          <p>Please check your inbox and click the verification link.</p>
          
          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}
          
          <div className="verification-actions">
            <button 
              onClick={handleSendVerification}
              className="auth-button secondary"
              disabled={loading || countdown > 0}
            >
              {countdown > 0 
                ? `Resend in ${countdown}s` 
                : loading 
                  ? 'Sending...' 
                  : 'Resend Email'
              }
            </button>
            
            <button 
              onClick={handleRefresh}
              className="auth-button primary"
            >
              I've Verified My Email
            </button>
          </div>
          
          <div className="verification-info">
            <p><strong>Didn't receive the email?</strong></p>
            <ul>
              <li>Check your spam or junk folder</li>
              <li>Make sure you entered the correct email address</li>
              <li>Wait a few minutes before requesting another email</li>
            </ul>
          </div>

          <div className="verification-cancel">
            <button 
              onClick={handleStartOver}
              className="auth-button secondary"
            >
              Made a mistake? Cancel and start over
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification; 